import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import layout from '@/views/layout'
import { getToken } from '@/utils/auth'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'// Progress 进度条样式

const _import = require('./_import_' + process.env.NODE_ENV);
Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: _import('/login'),
      meta: {
        noAuth: true
      }
    },
    { 
      path:'/index',
      component:_import('/index/index')
    }
  ]
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  store.dispatch('initSysConfig').then(()=>{
    /* 判断要访问的路由是否需要权限访问 */
    if( to.meta && to.meta.noAuth ){
      next()
    }else{
      /* 判断是否有sessionId */
      //if( store.getters.hasSession ) {
      //暂时处理hasSession有时返回false的bug
      if( getToken() ? true : false ) {
        /* 判断是否已读取用户信息 */
        if( store.getters.hasUserInfo ) {
          next()
        }else {
          /* 获取用户信息 */
          store.dispatch('getUserInfo').then( res => {
            //newRouters.push( { path: '*', redirect: '/404', hidden: true } )
            //router.options.routes.push(...newRouters)

            let menuList = res.data.menus
            // console.log('menuList',menuList)
            let menuRouters = [] 
            /*先取出模块，没有父id的就是模块菜单*/
            menuList.forEach((m,i)=>{
              if(m.parent_id==0||m.parent_id=='0'){
                let module = {
                  path: '/' + m.path,
                  component: layout,
                  meta:{ id:m.id, title:m.title, fullPath: m.fullPath},
                  children:[
                    {
                      path:'',
                      name: m.path,
                      component:_import(m.fullPath),
                      meta:{
                        menuHide: true,
                        title: m.title
                      }
                    }
                  ]
                }
                menuRouters.push(module)
              }
            })
            function convertTree(routers){
              routers.forEach(r=>{
                menuList.forEach((m,i)=>{
                  if(m.parent_id && m.parent_id == r.meta.id){
                    if(!r.children) r.children = []
                    let menu = {
                      name: m.path,
                      path: m.path,
                      component: _import(m.fullPath),
                      meta:{ id:m.id, title:m.title, fullPath:m.fullPath}
                    }
                    r.children.push(menu)
                  }
                })
                if(r.children) convertTree(r.children)
              })
            }
            convertTree(menuRouters)
            menuRouters.forEach((m,i)=>{
              if(m.children.length>1){
                m.meta.fullPath = m.children[1].meta.fullPath
                m.children[0].component = m.children[1].component
              }
            })
            // console.log('menuRouters', menuRouters)
            store.dispatch('setRouters', menuRouters)
            router.addRoutes(menuRouters)
            
            router.addRoutes( [{ path: '*', redirect: '/index' } ])
            next({ ...to, replace: true })
          })
        }
      }else{
        next('/login')
      }
    }
  })
  
  
})

router.afterEach((to,from) => {
  NProgress.done() // 结束Progress
  if(to.meta && to.meta.title){
    document.title = to.meta.title + ' | '+ store.state.sys.title
  }else{
    document.title = store.state.sys.title
  }
})

export default router
